<template>
  <v-app
    :class="[
      openDyslexic ? 'open-dyslexic' : '',
      $route.path === '/welcome' || $route.path == '/terms' ? 'border' : '',
      isAndroid ? 'android-top-safe-area android-bottom-safe-area' : '',
    ]"
  >
    <BypassBlock v-if="$route.path != '/welcome'"></BypassBlock>

    <Header
      v-if="
        $route.path != '/welcome' &&
        $route.name != 'user_register' &&
        $route.path != '/terms'
      "
    ></Header>

    <v-main
      id="main-content"
      tabindex="-1"
      :class="[
        'main-content',
        {
          'main-content--yellow-background':
            $route.name === 'opportunities_archive' || $route.name === 'posts',
        },
        {
          'main-content--green-background':
            $route.name === 'organisations_archive' ||
            $route.name === 'sign_in' ||
            $route.name === 'sign_up' ||
            $route.name === 'forgot_password' ||
            $route.name === 'user_profile' ||
            $route.name === 'user_edit' ||
            $route.name === 'blocked_users',
        },
        {
          'main-content--pink-background':
            $route.name === 'surveys' ||
            $route.name === 'toolkit_archive' ||
            $route.name === 'toolkit_search' ||
            $route.name === 'toolkit_article',
        },
        {
          'main-content--orange-background': $route.name === 'chats',
        },
        {
          'main-content--events': $route.name === 'events_archive',
        },
        {
          'main-content--offers': $route.name === 'offers_archive',
        },
      ]"
    >
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath" />
      </transition>

      <v-alert
        v-model="networkAlert"
        dense
        dismissible
        type="error"
        class="network-error"
        >Network Error. Unable to fetch live data</v-alert
      >
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/components/Header/Header";
import BypassBlock from "./components/App/BypassBlock.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import cookieConsent from "@/mixins/cookieConsent/index";

export default {
  name: "App",
  components: {
    Header,
    BypassBlock,
  },
  watch: {
    // '$route': 'currentRoute',
    $route: {
      immediate: true,
      handler(to) {
        console.log(to);
        if (to && to.name) {
          document.title = to.name.replace(/_|-|\./g, " ") || "App";
        } else {
          document.title = "App";
        }
      },
    },
  },
  data: () => ({
    routeName: null,
    alert: false,
    isAndroid: false,
  }),
  methods: {
    ...mapActions("hubbdata", ["updateLang", "setFont"]),
    ...mapActions("user", ["startPollingUserData"]),
    ...mapMutations("hubbdata", ["setNetworkAlert"]),
    currentRoute() {
      this.$nextTick(() => {
        this.routeName = this.$route.name;
      });
    },
    headerMounted() {
      console.log("header mounted");
    },
  },
  mounted() {
    const isApp = window.cordova;
    // initialize cookie consent if not in app
    if (!isApp) {
      cookieConsent.methods.updateGtagConsent();
    }

    if (localStorage.getItem("current_lang") !== null) {
      this.updateLang(localStorage.getItem("current_lang"));
    }

    this.setFont();

    if (this.isTokenSet) {
      this.startPollingUserData();
    }

    // Simple platform detection for applying Android-specific safe area styling
    try {
      this.isAndroid =
        window.cordova && window.cordova.platformId === "android";
    } catch (e) {
      this.isAndroid = false;
    }
  },
  computed: {
    ...mapGetters("hubbdata", ["translations", "openDyslexic"]),
    networkAlert: {
      get: function () {
        return this.$store.getters["hubbdata/getNetworkAlert"];
      },
      set: function (newValue) {
        this.setNetworkAlert(newValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.main-content {
  &:focus {
    outline: none !important;
  }

  &--yellow-background {
    background: linear-gradient(180deg, rgba($yellow, 0.5) 0%, $yellow 100%);
  }

  &--green-background {
    background: linear-gradient(180deg, rgba($green, 0.5) 0%, $green 100%);
  }

  &--pink-background {
    background: linear-gradient(180deg, rgba($pink, 0.5) 0%, $pink 100%);
  }

  &--orange-background {
    background: linear-gradient(180deg, rgba($orange, 0.5) 0%, $orange 100%);
  }

  &--events {
    background: linear-gradient(180deg, rgba($blue, 0.5) 0%, $blue 100%);
  }

  &--offers {
    background: linear-gradient(180deg, rgba($orange, 0.5) 0%, $orange 100%);
  }

  &--padding-top-none {
    padding-top: 0 !important;
  }
}
</style>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
a {
  color: #0062ae !important;
  // text-decoration: underline !important;
}

*:focus {
  outline: $black solid 2px;
}

// a:focus {
//   outline: auto;
// }

.v-list-item__content .v-list-item__content:focus-within,
.v-list--two-line .v-list-item__content:focus-within,
.icons:focus .v-card {
  outline: #0062ae solid 3px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
  color: black !important;
  background-color: white;
}

////// APP TOUR PLUGIN /////

.v-step {
  border: 2px solid $black !important;
  max-width: 280px !important;
  background-color: #b8bbdb !important;
  border-radius: 20px !important;
  padding: 10px !important;
}

.v-step__header {
  border-bottom: 2px solid $black;
  font-size: 1.25rem;
  line-height: 1.5;
  color: $black;
  background-color: $blue !important;
  border-top-left-radius: 18px !important;
  border-top-right-radius: 18px !important;
  margin: -10px -10px 10px !important;
  padding: 10px !important;

  div {
    font-family: "balsamiq sans", sans-serif !important;
  }
}

.v-step__content {
  font-size: 0.875rem;
  line-height: 1.5;
  color: $black;
}

.v-step__button {
  border: 0 !important;
  border-radius: 0px !important;
  background-color: $black !important;
  font-size: 0.875rem !important;
  line-height: 1.3 !important;
  color: $blue !important;
  font-weight: 700 !important;
  text-align: center !important;
  padding: 5px 16px !important;
  text-decoration: none !important;
  height: auto !important;
  transition: none !important;

  &:focus {
    outline: 2px solid $black !important;
    outline-offset: 2px !important;
  }
}

.v-step__arrow::before {
  background-color: $black !important;
}

.network-error {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  margin-bottom: 0;
  border-radius: 0 !important;
  font-weight: 700;

  @media (min-width: 960px) {
    left: 256px;
  }

  .v-btn {
    &:before {
      display: none;
    }

    &:focus,
    &:hover {
      outline: 2px solid white;
      outline-offset: 2px;
    }
  }
}
</style>
